const INPUT_SELECTOR = '.in-url-slug';

const UrlSlugInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        $scope.on('input', INPUT_SELECTOR, function () {
            const $input = $(this);

            $input.val($input.val().toLowerCase());
        });
    },
};

export default UrlSlugInput;
